import React, { useState } from "react";
import BorderHeading from "../../../../components/heading/BorderHeading";
import { Button, Grid, Modal, TextField } from "@mui/material";
import { updateCouponInfoBody, popupType } from "../../../../types/types";
import "./EditModal.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { updateCouponInfo } from "../../../../services/manageCouponService";

const EditModal = (props: any) => {
  const [endDate, setEndDate] = useState<Dayjs>(
    dayjs(props.couponData.endDate)
  );

  const startDate = new Date(props.couponData.startDate);
  startDate.setHours(0, 0, 0, 0);
  const formattedStartDate = startDate.toLocaleDateString();

  const handleSubmit = async () => {
    const end = moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59");
    let requestBody: updateCouponInfoBody = {
      discountId: "",
      endDate: "",
    };
    requestBody.discountId = props.couponData.discountId;
    requestBody.endDate = end;

    const response = await updateCouponInfo(requestBody);
    if (response.data.message === "SUCCESS") {
      props.setOpenModal(false);
      props.setIsUpdated(true);
    }
  };
  const handleCancel = () => {
    props.setOpenModal(false);
  };

  return (
    <Modal className="scheme-info-modal" open={props.openModal}>
      <div className="main-container-edit-modal">
        <div className="modal-heading-edit-modal">
          <h2>Scheme Information</h2>
        </div>
        <div className="coupon-details">
          <BorderHeading>Coupon Details</BorderHeading>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Start Date"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={formattedStartDate}
                margin="normal"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="End Date"
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  // maxDate={dayjs()}
                  onChange={(value) => {
                    if (value) {
                      setEndDate(value);
                    }
                  }}
                  renderInput={(props) => (
                    <TextField
                      {...props}
                      margin="normal"
                      id="outlined-basic"
                      variant="outlined"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Coupon Id"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.id}
                margin="normal"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Coupon Name"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.discountName}
                margin="normal"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Coupon Description"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.schemeDescription}
                margin="normal"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Coupon Criteria"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.creteria}
                margin="normal"
              ></TextField>
            </Grid>
          </Grid>
        </div>
        <div className="coupon-details">
          <BorderHeading>Conditions</BorderHeading>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Min. Value"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.start_amount}
                margin="normal"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Max. Value"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.end_amount}
                margin="normal"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Discounted Amount"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.discounted_amount}
                margin="normal"
              ></TextField>
            </Grid>
          </Grid>
        </div>
        <div className="coupon-details">
          <BorderHeading>Discount Details</BorderHeading>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Coupon Type"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                value={props.couponData.type}
                margin="normal"
              ></TextField>
            </Grid>
          </Grid>
        </div>
        <div className="buttons-edit-modal">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#237C9D" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#237C9D" }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditModal;
